export const constants = {
    apiBaseUrl: import.meta.env.VITE_APIBASEURL,
    internationalisation: import.meta.env.VITE_INTERNATIONALISATION,
    showCaptcha: import.meta.env.VITE_SHOW_CAPTCHA,
    captchaSiteKey: import.meta.env.VITE_CAPTCHA_SITE_KEY,
};
